import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import { OrdersList, OrderDetail } from "@/pages/Orders";
import Admin from "@/pages/Admin";
import Delivery from "@/pages/Delivery";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback fragment synchronously during render (not in useEffect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing/>}/>
      <Route path="/login" element={<Login/>}/>
      <Route path="/auth/callback" element={<AuthCallback/>}/>
      <Route path="/shop" element={<Shop/>}/>
      <Route path="/product/:id" element={<ProductDetail/>}/>
      <Route path="/cart" element={<Cart/>}/>
      <Route path="/checkout" element={<ProtectedRoute allow={["customer","admin"]}><Checkout/></ProtectedRoute>}/>
      <Route path="/orders" element={<ProtectedRoute><OrdersList/></ProtectedRoute>}/>
      <Route path="/orders/:id" element={<ProtectedRoute><OrderDetail/></ProtectedRoute>}/>
      <Route path="/admin" element={<ProtectedRoute allow={["admin"]}><Admin/></ProtectedRoute>}/>
      <Route path="/delivery" element={<ProtectedRoute allow={["delivery","admin"]}><Delivery/></ProtectedRoute>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRouter/>
            <Toaster position="top-center" richColors closeButton/>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
